import Solution0 from "./assets/icons/Solution0.svg";
import Solution1 from "./assets/icons/Solution1.svg";
import Solution2 from "./assets/icons/Solution2.svg";
import Solution3 from "./assets/icons/Solution3.svg";
import Solution4 from "./assets/icons/Solution4.svg";
import Solution5 from "./assets/icons/Solution5.svg";
import Solution6 from "./assets/icons/Solution6.svg";
import Solution7 from "./assets/icons/Solution7.svg";
import { linksConstants } from "../../../../constants/linksConstants";
import Image from "next/image";

const solutions = [
  {
    img: Solution0,
    name: "KYB Compliance",
    description: "Conduct due diligence checks on businesses.",
    url: linksConstants.USECASE_KYB,
  },
  {
    img: Solution1,
    name: "KYC Compliance",
    description: "Onboard customers subject to AML regulations.",
    url: linksConstants.USECASE_KYC,
  },
  {
    img: Solution2,
    name: "Application Prefill",
    description: "Populate key fields using minimal inputs.",
    url: linksConstants.USECASE_PREFILL,
  },
  {
    img: Solution3,
    name: "Business Risk Assessment",
    description: "Access business financials and credit signals.",
    url: linksConstants.USECASE_BUSINESS_ONBOARDING,
  },
  {
    img: Solution4,
    name: "Contact Data Enrichment",
    description: "Enhance customer lists across key fields.",
    url: linksConstants.USECASE_DATA_ENRICHMENT,
  },
  {
    img: Solution5,
    name: "Credit Bureau  Integration",
    description: "Integrate with credit bureaus globally.",
    url: linksConstants.USECASE_CREDIT_BUREAU,
  },
  {
    img: Solution6,
    name: "Portfolio Monitoring",
    description: "Identify customer engagement opportunities.",
    url: linksConstants.USECASE_PORTFOLIO_MONITORING,
  },
  {
    img: Solution7,
    name: "Lead Targeting",
    description: "Generate, enrich, and prioritize customer lists.",
    url: linksConstants.USECASE_LEAD_TARGETING,
  },
];

export const Solutions = () => {
  return (
    <section className="home_solutions-background">
      <div className="home_solutions">
        <section className="section-layout">
          <h2>Access the world’s best data for your use case</h2>
          <p className="home_solutions-text">
            Demyst addresses business challenges with its platform powered by a certified external
            data ecosystem and a single, global API. The platform enables custom solutions on the
            fly based on changing workflow requirements. Some common examples:
          </p>
          <div className="home_solutions-grid">
            {solutions.map(({ img, name, description, url }) => (
              <a key={name} href={url}>
                <div className="home_solutions-card">
                  <Image src={img.src} alt="" width="48" height="48" loading="lazy" />
                  <div className="home_solutions-card_text">
                    <h3>{name}</h3>
                    <p>{description}</p>
                    <span className="home_solutions-card-btndummy">Learn More</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </section>
      </div>
    </section>
  );
};
